// components/patients/BulkActionsBar.jsx
import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onDelete, onClearSelection }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);

  if (selectedCount === 0) return null;

  const handleDeleteClick = () => {
    setShowConfirm(true);
  };

  const handleConfirmDelete = async () => {
    setDeleting(true);
    await onDelete();
    setDeleting(false);
    setShowConfirm(false);
  };

  const handleCancelDelete = () => {
    setShowConfirm(false);
  };

  return (
    <>
      <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 animate-fade-in">
        <div className="bg-card border border-border rounded-lg shadow-modal px-6 py-4 flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-medium">
              {selectedCount}
            </div>
            <span className="text-sm font-medium text-foreground">
              {selectedCount === 1 ? 'patient sélectionné' : 'patients sélectionnés'}
            </span>
          </div>

          <div className="h-6 w-px bg-border" />

          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={handleDeleteClick}
              iconName="Trash2"
              iconPosition="left"
              disabled={deleting}
            >
              Supprimer
            </Button>

            <Button
              variant="ghost"
              size="sm"
              onClick={onClearSelection}
              iconName="X"
              disabled={deleting}
            >
              Annuler
            </Button>
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirm && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center">
          {/* Backdrop */}
          <div 
            className="absolute inset-0 bg-black/50 backdrop-blur-sm"
            onClick={handleCancelDelete}
          />

          {/* Modal */}
          <div className="relative bg-card border border-border rounded-lg shadow-lg w-full max-w-md mx-4">
            {/* Header */}
            <div className="flex items-center gap-3 p-6 border-b border-border">
              <div className="w-10 h-10 bg-destructive/10 rounded-lg flex items-center justify-center">
                <Icon name="AlertTriangle" size={20} className="text-destructive" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-foreground">
                  Confirmer la suppression
                </h2>
                <p className="text-sm text-muted-foreground">
                  Cette action est irréversible
                </p>
              </div>
            </div>

            {/* Content */}
            <div className="p-6">
              <p className="text-foreground mb-2">
                Êtes-vous sûr de vouloir supprimer {selectedCount === 1 ? 'ce patient' : `ces ${selectedCount} patients`} ?
              </p>
              <p className="text-sm text-muted-foreground">
                Toutes les données associées (dossiers, rendez-vous, historique) seront également supprimées de manière permanente.
              </p>
            </div>

            {/* Actions */}
            <div className="flex items-center gap-3 p-6 border-t border-border">
              <Button
                type="button"
                variant="outline"
                onClick={handleCancelDelete}
                className="flex-1"
                disabled={deleting}
              >
                Annuler
              </Button>
              <Button
                type="button"
                variant="destructive"
                onClick={handleConfirmDelete}
                className="flex-1"
                disabled={deleting}
                iconName={deleting ? 'Loader2' : 'Trash2'}
                iconPosition="left"
              >
                {deleting ? 'Suppression...' : 'Supprimer'}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BulkActionsBar;